import React, { useState, useEffect } from 'react';
import { history } from '../../helpers/history';
import superClientServiceObj from '../../services/super-client.service';
import ExportToExcel from '../superadmin/ExportToExcel';
import EditSuperClient from './EditSuperClient';
import ModelPopup from '../../helpers/ModelPopup';
import { Link } from 'react-router-dom';

const SearchGridSuperClient = ({ headersdata, placeholdervalue, calledfrom }) => {
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuspended, setShowSuspended] = useState(true);
  const [editClient, setEditClient] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  useEffect(() => {
    fetchClients();
  }, [showSuspended]);

  const fetchClients = async () => {
    setLoading(true);
    try {
      const resp = await superClientServiceObj.getSuperClientList(showSuspended);
      if (resp?.data?.payload) {
        const sorted = [...resp.data.payload].sort((a, b) =>
          a.name.localeCompare(b.name)
        );
        setClients(sorted);
      }
    } catch (error) {
      console.error('Error fetching clients', error);
      setClients([]);

    } finally {
      setLoading(false);
    }
  };

  const handleTabClick = suspended => {
    setShowSuspended(suspended);
  };

  const handleRowClick = client => {
    const { id, userId, status } = client;
    history.push('/superclientdetails', { id, userId, status });
  };

  const handleEditClick = client => {
    setEditClient(client);
    setShowEditModal(true);
  };

  return (
    <div className="mt-md-0 mt-4">
      {calledfrom !== 'dashboard' && (
        <div className="bo-tabs-mbl">
          <ul className="nav nav-tabs" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link d-flex align-items-center ${showSuspended ? 'active' : ''}`}
                type="button"
                onClick={() => handleTabClick(true)}
              >
                <span className="icon-client"></span>Super Clients
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className={`nav-link d-flex align-items-center ${!showSuspended ? 'active' : ''}`}
                type="button"
                onClick={() => handleTabClick(false)}
              >
                <span className="icon-client"></span>Suspended Super Clients
              </button>
            </li>
            <li className="nav-item ms-auto">
              <div className="mt-16 mt-sm-0 mb-16">
                <ExportToExcel Dataset={clients} calledfrom="client" Name="Client" />
              </div>
            </li>
          </ul>
        </div>
      )}
      <div className={calledfrom === 'dashboard' ? '' : 'tab-content'} id="myTabContent2">
        <div className="tab-pane fade show active" id="allClients" role="tabpanel">
          {loading ? (
            <div className="loading-more">
              <div className="loader"><div></div></div>
              <p>loading data</p>
            </div>
          ) : clients.length === 0 ? (
            <div className="d-flex align-content-center justify-content-center no-clients-msg">
              <div className="text-center">
                <span className="icon-clients-empty">
                  <span className="path1"></span><span className="path2"></span>
                  <span className="path3"></span><span className="path4"></span>
                  <span className="path5"></span><span className="path6"></span>
                </span>
                <h3>Empty Clients Listing</h3>
                <h6>There is no Super Client(s) available for now.</h6>
              </div>
            </div>
          ) : (
            <div className="table-wrap">
              <table className="table table-borderless bo-table table-cards table-clients">
                <thead>
                  <tr>
                    {Object.values(headersdata).map((header, idx) => (
                      <th key={idx}>{header.toUpperCase()}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {clients.map(client => (
                    <tr key={client.id}>
                      <td style={{ textTransform: 'uppercase' }}>
                        <span className="td-logo" onClick={() => handleRowClick(client)}>
                          {client.name.charAt(0)}
                        </span>
                      </td>
                      <td>
                        <span
                          style={{ cursor: 'pointer', color: '#0d6efd' }}
                          title={client.name}
                          onClick={() => handleRowClick(client)}
                        >
                          {client.name.length > 200
                            ? `${client.name.substr(0, 200)}...`
                            : client.name}
                        </span>
                      </td>
                      <td>{client.email}</td>
                      <td>
                        <span
                          className="icon-show"
                          onClick={() => handleEditClick(client)}
                        ></span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
      {showEditModal && (
        <EditSuperClient
          show={showEditModal}
          onHide={() => setShowEditModal(false)}
          editsuperclient={editClient}
          onAddClient={() => {
            setShowEditModal(false);
            setShowSuccessModal(true);
          }}
          calledfrom={!showSuspended ? 'suspendclient' : 'superclient'}
        />
      )}
      {showSuccessModal && (
        <ModelPopup
          show={showSuccessModal}
          onHide={() => setShowSuccessModal(false)}
          modelheading=""
          showheader="false"
          className="smallPopup issueCardSmall"
          dialogClassName="modal-dialog modal-dialog-centered mwidth-42"
          backdrop="static"
          keyboard={false}
          modelbody={[
            <div key="body" className="row">
              <div className="col-md-12 text-center">
                <div className="icon-alert icon-alert-popup">
                  <span className="icon-successful">
                    <span className="path1"></span>
                    <span className="path2"></span>
                  </span>
                </div>
                <h2>Successful</h2>
                <p>
                  {!showSuspended
                    ? 'Client UnSuspended Successfully'
                    : 'Client Edit Successfully'}
                </p>
                <div className="form-group submit-field mt-40 mb-0">
                  <Link
                    to="#"
                    className="btn btn-large w-100"
                    onClick={() => window.location.reload()}
                  >
                    Done
                  </Link>
                </div>
              </div>
            </div>,
          ]}
        />
      )}
    </div>
  );
};

export default SearchGridSuperClient;
